export function isValidForm<T>(form: HTMLFormElement, errors: T) {
  return form.checkValidity && Object.values(errors).every((k) => !k);
}

// FIXME: T extends Response<T>
export function isSuccessfulResponse<T extends { errors?: {} | string | null, message?: string }>({errors = "", message = ""}: T) {
  // FIXME: WTF (const a: {} = "")
  return !message && (typeof errors === "object" && errors !== null ? Object.values(errors).every((k) => !k) : !errors);
}
